import React from "react";
import { GlassCard } from "./GlassCard";

export const EmptyState = ({ icon, title, body, action, testId }) => (
    <GlassCard padding="p-10" testId={testId}>
        <div className="flex flex-col items-center text-center max-w-md mx-auto">
            {icon && (
                <div className="h-16 w-16 rounded-full bg-[color:var(--copper-subtle)] grid place-items-center mb-4 text-[color:var(--copper)]">
                    {icon}
                </div>
            )}
            <h3 className="font-display text-xl text-[color:var(--slate-deep)]">{title}</h3>
            {body && (
                <p className="mt-2 text-sm text-[color:var(--slate-mid)] font-body leading-relaxed">
                    {body}
                </p>
            )}
            {action && <div className="mt-5">{action}</div>}
        </div>
    </GlassCard>
);
